import { z } from "zod";

/// Search params for the public /pricing page.
///
/// Public links tolerate unknown campaign keys and malformed known values.
/// Keep tracking parameters when the pricing controls update the URL, and
/// fall back to the page defaults when currency or buy is not a string.
///
/// Fix round 2, important 4: `currency` and `buy` used to be plain
/// `useState` in the route (this repo's S3 rule names both as its canonical
/// violation: state that should be a URL so it's linkable and back-button
/// aware). Moving them here means `/pricing?currency=INR` is a real,
/// shareable link, and pressing Back while the checkout dialog is open pops
/// `buy` off the URL and closes it instead of leaving the buyer on a stale
/// page with no way back.
export const pricingSearchSchema = z
  .object({
    /// Buyer-selected currency toggle. Undefined until the buyer picks one
    /// explicitly; the route falls back to `defaultCurrency(...)` (USD if
    /// priced, else whatever the shore does price) until then.
    currency: z.string().optional().catch(undefined),
    /// planKey of the tier whose checkout dialog is currently open. Absent
    /// means no dialog is open.
    buy: z.string().optional().catch(undefined),
  })
  .passthrough();

export type PricingSearch = z.infer<typeof pricingSearchSchema>;
